// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e20a856f","453":"e8d04ed2","732":"ce0aa5aa"}[chunkId] + ".chunk.js";
};